import { de } from "intl-tel-input/i18n";
import { useEffect } from "react";

const PayUForm = ({ payment }) => {
  useEffect(() => {
    // Auto-submit form jab component render hoga
    document.forms.payuForm.submit();
  }, []);

  if (!payment) return null;

  return (
    <div className="flex items-center justify-center h-screen bg-gray-100">
      <form
        name="payuForm"
        method="POST"
        action={payment.action}
        className="hidden"
      >
        {Object.entries(payment.fields).map(([key, value]) => (
          <input key={key} type="hidden" name={key} value={value} />
        ))}
      </form>
      <p className="text-lg font-semibold">Redirecting to PayU...</p>
    </div>
  );
};

export default PayUForm;
